// App-icon badge helpers.
//
// Safe no-ops on desktop/web: window.electron.badge / push.removeAllDelivered
// only exist on the Capacitor native build (capacitor-shim.js). Every call is
// guarded + try/caught so this can be imported and called from shared renderer
// code without any platform branching at the call site.

export async function syncAppBadge(count) {
    try {
        const badge = typeof window !== 'undefined' && window.electron && window.electron.badge;
        if (badge && typeof badge.set === 'function') {
            await badge.set(Math.max(0, parseInt(count, 10) || 0));
        }
    } catch (_) { /* badge is best-effort */ }
}

// Clear notifications this app delivered to the system tray. On Android this is
// what removes the launcher "notification dot" after the user reads/clears
// in-app; on iOS it clears Notification Center entries.
export async function clearDeliveredNotifications() {
    try {
        const push = typeof window !== 'undefined' && window.electron && window.electron.push;
        if (push && typeof push.removeAllDelivered === 'function') {
            await push.removeAllDelivered();
        }
    } catch (_) { /* best-effort */ }
}
